import { v4 as uuidv4 } from 'uuid'
import { initialAddTitles, initialAddItems } from "./items"

export const initialCreateBudgetNew = () => {
    return {
        id: 0,
        numero: '000000',
        referencia: 'nuevo ppto gasto',
        estado: 'presupuesto',
        total_ppto: 0,
        total_gasto_real: 0,
        margen_gasto_p: 0,
        porcentaje_gasto_real: 0,
        total_por_gastar: 0,
        porcentaje_por_gastar: 0,
        id_moneda: 3, // soles
        moneda: 'soles',
        separacion_miles: ',',
        separacion_decimales: '.',
        simbolo: 'S/',
        fecha_asignacion_ini: new Date(),
        validacion_estado: null,
        validacion_nota: null,
        validacion_rentabilidad_optima: null,
        validacion_id_validador: null,
        validacion_id_regla: null,
        validacion_descripcion_regla: null,
        items: [],
        cant_items: 0,
        reading_mode: false,
        is_template: false,
        valor_tipo_cambio: null,
        temporalidad: 'mensual',
        id_tipo_doc: null
    }
}

export const initialCreateBudgetDuplicate = async (currentData = null) => {

    const { items: itemsOd } = currentData

    const getNewItems = async (currentItems, newIdTitle) => {
        let newItemsByTitle = []

        for (let x = 0; x < currentItems.length; x++) {
            let currentItem = currentItems[x]
            const newIdItem = uuidv4()

            const sorting = currentItem.sorting

            const params = {
                newId: newIdItem,
                idTitle: newIdTitle,
                sorting: sorting,
                data: currentItem,
                categoryId: null
            }

            const newItem = await initialAddItems(params)

            newItemsByTitle = [
                ...newItemsByTitle,
                newItem
            ]

        }

        return newItemsByTitle

    }

    let newItemsAll = []
    for (let i = 0; i < itemsOd.length; i++) {
        const currentTitle = itemsOd[i]
        const currentItems = currentTitle.items

        const newIdTitle = uuidv4()
        const newTitle = await initialAddTitles(newIdTitle, currentTitle)

        // get Items
        const newItemsByTitle = await getNewItems(currentItems, newIdTitle)

        newItemsAll = [
            ...newItemsAll,
            {
                ...newTitle,
                items: newItemsByTitle
            }
        ]
    }

    return {
        id: 0,
        numero: '000000',
        referencia: `COPIA ${currentData?.referencia}`,
        estado: 'presupuesto',
        total_ppto: currentData?.total_ppto || 0,
        total_gasto_real: 0,
        margen_gasto_p: 0,
        porcentaje_gasto_real: 0,
        total_por_gastar: 0,
        porcentaje_por_gastar: 0,
        id_moneda: currentData?.id_moneda || 3,
        moneda: currentData?.moneda || 'soles',
        separacion_miles: currentData?.separacion_miles || ',',
        separacion_decimales: currentData?.separacion_decimales || '.',
        simbolo: currentData?.simbolo || 'S/',
        fecha_asignacion_ini: currentData?.fecha_asignacion_ini || new Date(),
        items: newItemsAll,
        cant_items: 0,
        reading_mode: false,
        is_template: false,
        in_flow: currentData?.in_flow,
        valor_tipo_cambio: currentData?.valor_tipo_cambio,
        temporalidad: currentData?.temporalidad
    }

}

export const initialCreatePptoGasto = async () => {
    return {
        id: 0,
        numero: '000000',
        referencia: 'nuevo plan de gasto',
        sub_total: 0,
        total: 0,
        total_gasto_actual: 0,
        margen_gasto_actual: 0,
        total_saldo: 0,
        margen_saldo: 0,
        id_moneda: 3, // soles
        moneda: 'soles',
        separacion_miles: ',',
        separacion_decimales: '.',
        simbolo: 'S/',
        items: [],
        valor_tipo_cambio: null,
        temporalidad: 'mensual'
    }
}

export const parseToNum = (value = 0, decimals = 2, round = false) => {
    if (round) {
        return parseFloat(parseFloat(value).toFixed(decimals))
    } else {
        return parseFloat(value)
    }
}